export default "__VITE_ASSET__feb63e39__"